var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetention(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.407,
    height: 31.937,
    viewBox: "0 0 32.407 31.937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15956",
    "data-name": "Group 15956",
    transform: "translate(-1352.48 -370.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "customer-retention",
    d: "M38.762,41.026a4.635,4.635,0,1,0-4.634-4.635A4.642,4.642,0,0,0,38.762,41.026Zm15.566-.861a.4.4,0,0,1,.4.4,15.971,15.971,0,0,1-30.44,6.76l-.939,2.877a.4.4,0,0,1-.508.259.4.4,0,0,1-.258-.509l1.232-3.779a.411.411,0,0,1,.2-.235.407.407,0,0,1,.31-.024l3.779,1.233a.4.4,0,0,1-.249.766l-2.831-.924a15.163,15.163,0,0,0,28.9-6.425A.4.4,0,0,1,54.328,40.165ZM49.37,33.817a.4.4,0,1,1,.266-.761l2.814.985A15.162,15.162,0,0,0,23.6,40.568a.4.4,0,1,1-.807,0,15.971,15.971,0,0,1,30.4-6.852l1-2.852a.4.4,0,1,1,.76.266l-1.315,3.752a.4.4,0,0,1-.379.27.409.409,0,0,1-.134-.023Zm-7.094,8.15H35.248a3.711,3.711,0,0,0-3.706,3.707V49.38H45.984V45.673A3.711,3.711,0,0,0,42.276,41.966Z",
    transform: "translate(1329.914 345.425)",
    fill: "#2179fe",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetention);
export default __webpack_public_path__ + "static/media/Retention.13f8a6b0.svg";
export { ForwardRef as ReactComponent };